import React from 'react';
import {
    TextField,
    Button,
    Slider,
    Typography,
    Box, CircularProgress, IconButton, Divider
} from '@material-ui/core';
import {Autocomplete} from '@material-ui/lab';
import ReactQuill from 'react-quill';
import {KeyboardDatePicker} from '@material-ui/pickers';
import {
    quillModules,
    priorityOptions, statusOptions,
} from './constants';
import FileUpload from "../global/FileUpload";
import DescriptionIcon from "@material-ui/icons/Description";
import CommentHistoryTable from "./CommentHistoryTable";

const TodoForm = ({
  newTodo,
  allUsers,
  isEditing,
  isOwner,
  onChange,
  onSave,
  onProgressChange,
  files,            // <-- add this
  newFiles,         // <-- add this
  handleGeneralFileAdd,
  handleGeneralFileDelete,
  handleAttachmentPreview,
  comments,         // <-- add this
  handleCommentUpdate,
  currentUser,
  handleCommentEdit,
  handleCommentDelete
}) => {

  return (
      <div style={{padding: 24, maxWidth: 1100, margin: '24px auto'}}>

          {/* Title */}
          <TextField
              variant="outlined"
              label="Title"
              value={newTodo.title}
              disabled={isEditing && !isOwner}
              onChange={e => onChange('title', e.target.value)}
              fullWidth
              style={{marginBottom: 16}}
          />

          {/* Assign To */}
          <Autocomplete
              options={allUsers}
              disabled={isEditing && !isOwner}
              getOptionLabel={option => [option.firstname, option.lastname].filter(Boolean).join(' ')}
              autoHighlight
              disableClearable
              value={allUsers.find(user => user.userId === newTodo.assignedTo) || null}
              onChange={(event, newValue) => onChange('assignedTo', newValue?.userId || '')}
              renderInput={(params) => (
                  <TextField
                      {...params}
                      label="Assign To"
                      variant="outlined"
                      InputLabelProps={{shrink: true}}
                      style={{marginBottom: 16, marginTop: 16}}
                  />
              )}
          />

          {/* Priority */}
          <Autocomplete
              options={priorityOptions}
              disabled={isEditing && !isOwner}
              getOptionLabel={(option) => option.label}
              value={priorityOptions.find(opt => opt.label === newTodo.priority) || null}
              onChange={(event, newValue) => onChange('priority', newValue?.label || '')}
              renderInput={(params) => (
                  <TextField
                      {...params}
                      label="Priority"
                      variant="outlined"
                      fullWidth
                      style={{marginTop: 16}}
                      InputProps={{
                          ...params.InputProps,
                          startAdornment: newTodo.priority ? (
                              <div
                                  style={{
                                      width: 16,
                                      height: 16,
                                      borderRadius: '50%',
                                      backgroundColor: priorityOptions.find(o => o.label === newTodo.priority)?.color || '#ccc',
                                      display: 'inline-block',
                                      marginRight: 8,
                                      verticalAlign: 'middle',
                                  }}
                              />
                          ) : null,
                      }}
                  />
              )}
          />

          {/* Progress */}
          <Box className="progress-container">
              <Box flex={1}>
                  <Typography variant="subtitle2" gutterBottom>
                      Progress
                  </Typography>
                  <Slider
                      value={newTodo.progress}
                      min={0}
                      max={100}
                      step={1}
                      onChange={(e, value) => onProgressChange(value)}
                  />
              </Box>

              <Box position="relative" display="inline-flex">
                  <CircularProgress
                      variant="determinate"
                      value={newTodo.progress}
                      size={80}
                      thickness={4}
                      color={
                          newTodo.progress === 100
                              ? "secondary"
                              : newTodo.progress > 0
                                  ? "primary"
                                  : "inherit"
                      }
                  />
                  <Box
                      top={0}
                      left={0}
                      bottom={0}
                      right={0}
                      position="absolute"
                      display="flex"
                      alignItems="center"
                      justifyContent="center"
                  >
                      <Typography variant="h6">{newTodo.progress}%</Typography>
                  </Box>
              </Box>
          </Box>

          {/* Status */}
          <Autocomplete
              options={statusOptions}
              disabled={isEditing && !isOwner}
              getOptionLabel={(option) => option.label}
              value={statusOptions.find(opt => opt.label === newTodo.status) || null}
              onChange={(event, newValue) => onChange('status', newValue?.label || '')}
              renderInput={(params) => (
                  <TextField
                      {...params}
                      label="Status"
                      variant="outlined"
                      fullWidth
                      style={{marginTop: 16}}
                      InputProps={{
                          ...params.InputProps,
                          startAdornment: newTodo.status ? (
                              <div
                                  style={{
                                      width: 16,
                                      height: 16,
                                      borderRadius: '50%',
                                      backgroundColor: statusOptions.find(o => o.label === newTodo.status)?.color || '#ccc',
                                      display: 'inline-block',
                                      marginRight: 8,
                                      verticalAlign: 'middle',
                                  }}
                              />
                          ) : null,
                      }}
                  />
              )}
          />

          {/* Due Date */}
          <KeyboardDatePicker
              disabled={isEditing && !isOwner}
              margin="normal"
              label="Due Date"
              format="MM/dd/yyyy"
              value={newTodo.dueDate}
              onChange={date => onChange('dueDate', date)}
              fullWidth
              inputVariant="outlined"
          />

          {/* Description */}
          <Box style={{marginTop: 16}}>
              <ReactQuill
                  readOnly={isEditing && !isOwner}
                  theme="snow"
                  value={newTodo.description}
                  modules={quillModules}
                  onChange={(value) => onChange('description', value)}
                  placeholder="Add details, bullet points, links…"
              />
          </Box>



              <div style={{width: '98%', marginTop:'24px'}}>
                  <CommentHistoryTable
                        disabled={false}
                       comments={comments}                     // passed from parent
                       newComment={newTodo.commentsInput || ''} // newTodo comes from props
                       handleCommentUpdate={handleCommentUpdate}
                       currentUser={currentUser}
                       handleCommentEdit={handleCommentEdit}
                       handleCommentDelete={handleCommentDelete}
                       type="todo"
                  />
              </div>



          <div style={{width: '98%', marginTop: 16}}>
              <br/>
              <Typography
                  variant="h5"
                  style={{
                      alignSelf: 'flex-start',
                      marginBottom: '10px',
                  }}
              >
                  Attachments
              </Typography>
              <div className="attachmentsRow">

                  {files?.length > 0 &&
                    files.map((file, index) => {
                        const displayName =
                            file.displayName.length > 15
                                ? file.displayName.substring(0, 15) + '...'
                                : file.displayName;

                        return (
                            <div key={index} className="pdf-icon" style={{ display: 'inline-flex', flexDirection: 'column', alignItems: 'left', margin: '10px', width: '120px' }}>
                                <IconButton
                                    aria-label="preview file"
                                    onClick={() => handleAttachmentPreview(file, index)}
                                    style={{ width: '60px', height: '60px' }}
                                >
                                    <DescriptionIcon fontSize="large"/>
                                </IconButton>
                                <div style={{ marginTop: '5px', textAlign: 'center', fontSize: '12px', color: 'black' }}>
                                    {displayName}
                                </div>
                            </div>
                        );
                    })
                }
              </div>

                <Divider
                      className="section-divider"
                      style={{ marginLeft: '10px' }}
                    />

              <div style={{alignSelf: 'flex-start'}}>
                  <FileUpload
                      handleFileAdd={(file) =>
                          handleGeneralFileAdd(file)
                      }
                      handleFileDelete={(file, fileIndex) =>
                          handleGeneralFileDelete(file, fileIndex)
                      }
                       files={newFiles || []}
                      singleFileUpload={true}
                      isPackingSlip={true}
                  />
              </div>



          </div>


          {/* Save Button */
          }
          <Box mt={4} display="flex" justifyContent="flex-end">
              <Button color="primary" variant="contained" onClick={onSave}>
                  {isEditing ? 'Update Task' : 'Create Task'}
              </Button>
          </Box>
      </div>
  )
      ;
};


export default TodoForm;
